module.exports = __webpack_public_path__ + "img/1c8697a5cb15d36436758a91e2a07f53.png";